/* eslint-disable @typescript-eslint/no-explicit-any */
import AuthSession from '@/services/auth-session';
import { publicRoutes } from '@/services/routes';
import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

const API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000/api/v1'
    : import.meta.env.VITE_API_URL;

if (!API_URL) {
  throw new Error('URL da API não foi configurada.');
}

const getCurrentToken = async (url: string) => {
  if (
    !url ||
    publicRoutes.includes(url) ||
    url.includes('courses-public') ||
    url.includes('rankings')
  ) {
    return '';
  }

  const authSession = await AuthSession.currentSession();

  if (!authSession?.user || !authSession.token) {
    throw new axios.Cancel('Sessão expirada. Faça o login novamente.');
  }
  return `Bearer ${authSession.token}`;
};

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// request header
api.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const token = await getCurrentToken(config.url);

  if (token) {
    config.headers.Authorization = token;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('>>>> INTERCEPTOR: ', {
      base: config.baseURL,
      url: config.url,
      params: JSON.stringify(config.data),
      token: config.headers.Authorization,
      method: config.method,
    });
  }
  return config;
});

// response parse
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (err: any) => {
    const invalidToken = err.response?.data?.message?.toLowerCase()?.includes('invalid or expired');
    if (invalidToken) {
      AuthSession.destroySession();
      window.location.href = '/';
    }
    return Promise.reject(err);
  },
);

export default api;
